module.exports = __webpack_public_path__ + "img/thumbnail_CaliforniaSealion_m_normal.5e90ac61.png";